import utils from "utils"
import {
    get
} from "https"
class editExternalSystemCtrl {
    constructor($scope, $state, $stateParams, httpRequest, logger) {
        $scope.dictData = {}
        const typecodeArr = ['event_type', 'encrypt_type', 'uims_interface_type', 'data_client_type', 'data_database_type','ivat_source_app_id']
        httpRequest.get_dictByTypeArr(typecodeArr).then((res) => {
            $scope.dictData = $.extend($scope.dictData, res.data.value)
        })
        // 用户信息
        const userInfo = JSON.parse(localStorage.user_info)
        const {
            clientId
        } = $stateParams
        if (clientId) $scope.isEdit = true
        $scope.params = {
            clientName: '',
            description: '',
            encryptType: '0',
            eventCallbackUri: '',
            eventTypes: [],
            status: 0,
            interfaceType: '1',
            orgIdList: [],
            sourceAppId:''
        }
        $scope.requesting = false
        $scope.status = true
        $scope.eventTypesList = [] // 订阅事件列表
        // 获取可订阅事件列表
        function getEventList() {
            const {
                tenantId
            } = userInfo
            httpRequest.get_getTenantExteralApi(tenantId, $scope.params.interfaceType).then((res) => {
                if (res.data.success) {
                    const list = []
                    const result = res.data.value
                    if (result && result.length) {
                        result.forEach((item) => {
                            const obj = {
                                name: item,
                                checked: false
                            }
                            list.push(obj)
                        })
                        $scope.eventTypesList = list
                        if (clientId && $scope.params.clientId) {
                            eventTypesListInit()
                        }
                    }
                }
            })
        }
        $scope.interfaceTypeChange = function () {
            getEventList()
        }
        // 编辑获取初始数据
        function getPageData() {
            httpRequest.get_qryClientDetails(clientId).then((res) => {
                if (res.data.success) {
                    $scope.params = res.data.value
                    // $scope.params = {
                    //     clientId: result.clientId,
                    //     clientName: result.clientName,
                    //     encryptType: result.encryptType,
                    //     description: result.description,
                    //     eventCallbackUri: result.eventCallbackUri,
                    //     eventTypes: result.eventTypes,
                    //     status: result.status,
                    // }
                    $scope.status = $scope.params.status == 1
                    // if ($scope.params.eventTypes && $scope.eventTypesList.length > 0) {
                    getEventList()
                    getOrg()
                    // }
                }
            })
        }
        if (clientId) {
            getPageData()
        } else {
            getOrg()
            getEventList()
        }
        // 给订阅事件列表赋初始值
        function eventTypesListInit() {
            $scope.eventTypesList.forEach((item) => {
                if ($scope.params.eventTypes.indexOf(item.name) > -1) {
                    item.checked = true
                }
            })
            // console.log($scope.eventTypesList)
        }
        // 保存
        $scope.addEternalSystem = function addEternalSystem() {
            $scope.params.eventTypes = []
            $scope.params.orgIdList = $scope.queryOrgConfig.defaultSelect.map(i => i.orgId)
            $scope.eventTypesList.forEach((item) => {
                if (item.checked == true) {
                    $scope.params.eventTypes.push(item.name)
                }
            })
            $scope.params.status = $scope.status == true ? 1 : 0
            if (!$scope.params.clientName) {
                logger.logError('请填写系统名称')
                return
            }
            if ($scope.params.eventTypes && $scope.params.eventTypes.length > 0 && !$scope.params.eventCallbackUri && $scope.params.interfaceType == 1) {
                logger.logError('请填写回调地址')
                return
            }
            const reg = /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/
            if ($scope.params.eventCallbackUri && !reg.test($scope.params.eventCallbackUri) && $scope.params.interfaceType == 1) {
                logger.logError('回调地址不合法')
                return
            }
            if ($scope.params.interfaceType == 1 && utils.lengthForString($scope.params.callbackMsgExp) > 256) return logger.logError('回调结果报文路径最多256个字符')

            // if ($scope.params.dataCollectClientUri && !reg.test($scope.params.eventCallbackUri)) {
            //     logger.logError('客户端地址不合法')
            //     return
            // }
            if (!$scope.params.eventCallbackUri) $scope.params.eventCallbackUri = ''
            if (!$scope.params.description) $scope.params.description = ''
            $scope.requesting = true
            if (clientId) { // 编辑
                httpRequest.post_updateClientDetails($scope.params).then((res) => {
                    $scope.requesting = false
                    if (res.data.success) {
                        logger.logSuccess('编辑成功')
                        $state.go('system.settingcenter.externalSystem.list')
                    } else {
                        logger.logSuccess(res.data.message)
                    }
                }).catch(() => {
                    $scope.requesting = false
                })
            } else { // 新增
                httpRequest.post_addClientDetails($scope.params).then((res) => {
                    $scope.requesting = false
                    if (res.data.success) {
                        logger.logSuccess('添加成功')
                        $state.go('system.settingcenter.externalSystem.list')
                    } else {
                        logger.logSuccess(res.data.message)
                    }
                }).catch(() => {
                    $scope.requesting = false
                })
            }
        }
        // 取消
        $scope.cancleHandle = function cancleHandle() {
            $state.go('system.settingcenter.externalSystem.list')
        }
        $scope.queryOrgConfig = {
            queryName: 'orgName',
            queryKey: 'orgId',
            queryType: 'statistTree',
            parentIdName: 'parentOrgId',
            multiple: true,
            parentId: '',
            defaultSelect: [],
        }

        function getOrg() {
            httpRequest.get_organization(0).then((res) => {
                if (res.data.success) {
                    $scope.orgList = JSON.parse(JSON.stringify(res.data.value))
                    const selectOrgList = []
                    $scope.params.orgIdList.forEach(i => {
                        res.data.value.forEach((item) => {
                            if (i == item.orgId) selectOrgList.push(item)
                        })

                    })
                    console.log(selectOrgList)
                    $scope.queryOrgConfig.defaultSelect = selectOrgList
                }
            })
        }
        $scope.orgSelectChange = function (v) {
            $scope.queryOrgConfig.defaultSelect = v
        }
    }
}

editExternalSystemCtrl.$inject = ['$scope', '$state', '$stateParams', 'httpRequest', 'logger']
export default editExternalSystemCtrl


// WEBPACK FOOTER //
// ./src/app/system/settingcenter/externalSystem/edit.js